// extracted by mini-css-extract-plugin
export var table = "_wq-0";